// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"3bb70923","374":"82f1e1d0","466":"076b515d","489":"9d442764","571":"140a6b6a","629":"4d3bfebb","721":"7f176572","752":"e1d8a631","815":"485d6db3","903":"95138749","921":"b6890d46","988":"59392f82"}[chunkId] + ".chunk.js";
};